/**
 * Datos de recetas de Intercasa
 * Contiene la información de las 12 recetas según recetas_individuales.md
 * 6 recetas de 2024 y 6 de 2025 para mantener contenido actualizado
 */

export const recipesData = [
  // ==========================================
  // RECETAS CON KETCHUP INTERCASA
  // ==========================================
  {
    id: 1,
    title: 'Pollo glaseado con ketchup y miel',
    description: 'Una receta rápida, jugosa y llena de sabor. El ketchup Intercasa aporta un toque dulce y equilibrado.',
    date: '2024-02-10',
    slug: 'pollo-glaseado-ketchup-miel',
    imageUrl: '/images/recipes/pollo-glaseado.webp',
    imageAlt: 'Pollo glaseado con ketchup y miel Intercasa',
    url: '/recetas/pollo-glaseado-ketchup-miel/',
    category: 'Principales',
    introduction: 'Una receta rápida, jugosa y llena de sabor. El ketchup Intercasa aporta un toque dulce y equilibrado, mientras que la miel carameliza el pollo de forma natural. Perfecta para comidas familiares o platos semanales fáciles.',
    ingredients: [
      '500 g de pollo en cubos',
      '4 cdas de ketchup Intercasa',
      '2 cdas de miel',
      '1 cda de salsa de soja',
      '1 diente de ajo rallado',
      'Sal y pimienta',
    ],
    instructions: [
      'Mezclar ketchup, miel, soja y ajo.',
      'Marinar el pollo 20-30 minutos.',
      'Cocinar en sartén hasta dorar.',
      'Añadir el resto de la marinada y dejar espesar.',
      'Una vez alcanzado el espesor deseado, espolvorea un poco de sésamo.',
      'Servir con arroz o puré.',
    ],
    intercasaProducts: [
      {
        name: 'Ketchup Intercasa',
        category: 'Ketchup',
        link: '/productos/retail/ketchup-pe'
      }
    ]
  },
  {
    id: 2,
    title: 'Arroz frito rojo estilo "omurice"',
    description: 'Un plato casero japonés muy popular, ideal para aprovechar arroz del día anterior.',
    date: '2024-04-18',
    slug: 'arroz-frito-rojo-omurice',
    imageUrl: '/images/recipes/arroz-omurice.webp',
    imageAlt: 'Arroz frito rojo estilo omurice con ketchup Intercasa',
    url: '/recetas/arroz-frito-rojo-omurice/',
    category: 'Principales',
    introduction: 'Un plato casero japonés muy popular, ideal para aprovechar arroz del día anterior. El ketchup Intercasa da color y un sabor dulce-salado característico.',
    ingredients: [
      '2 tazas de arroz cocido',
      '1/2 cebolla picada',
      '1/2 taza de zanahoria',
      '1/2 taza de jamón o pollo',
      '2-3 cdas de ketchup Intercasa',
      '1 cda de salsa de soja',
      '1 huevo (opcional)',
    ],
    instructions: [
      'Saltear cebolla y zanahoria picada en cubitos.',
      'Añadir el jamón o pollo en tamaño deseado (preferiblemente en taquitos).',
      'Agregar el arroz y mezclar todo en la sartén.',
      'Incorporar el ketchup Intercasa y la soja.',
      'Servir o cubrir con tortilla.',
    ],
    intercasaProducts: [
      {
        name: 'Ketchup Intercasa',
        category: 'Ketchup',
        link: '/productos/retail/ketchup-pe'
      }
    ]
  },
  {
    id: 3,
    title: 'Albóndigas en salsa de tomate frito',
    description: 'Un clásico reconfortante con una salsa sencilla pero muy sabrosa.',
    date: '2024-06-25',
    slug: 'albondigas-salsa-tomate-frito',
    imageUrl: '/images/recipes/albondigas-tomate.webp',
    imageAlt: 'Albóndigas en salsa de tomate frito Intercasa',
    url: '/recetas/albondigas-salsa-tomate-frito/',
    category: 'Principales',
    introduction: 'Un clásico reconfortante con una salsa sencilla pero muy sabrosa. El tomate frito Intercasa aporta el punto perfecto de acidez y dulzor.',
    ingredients: [
      '500 g de carne molida',
      '1 huevo',
      '1/2 taza pan rallado',
      '1/2 taza tomate frito Intercasa',
      '1/2 taza caldo',
      '1 cda de cebolla picada',
      'Orégano, sal y pimienta',
    ],
    instructions: [
      'Mezclar la carne con huevo y pan rallado.',
      'Formar albóndigas y dorarlas.',
      'Preparar salsa con tomate frito, caldo y especias.',
      'Añadir las albóndigas a la salsa.',
      'Cocinar 20 minutos.',
    ],
    intercasaProducts: [
      {
        name: 'Tomate Frito Intercasa',
        category: 'Tomates en Conserva',
        link: '/productos/retail/tomate-frito'
      }
    ]
  },

  // ==========================================
  // RECETAS CON SALSA BARBACOA INTERCASA
  // ==========================================
  {
    id: 4,
    title: 'Costillas BBQ al horno',
    description: 'Una receta irresistible, tierna y caramelizada. Ideal para reuniones o fines de semana.',
    date: '2024-08-12',
    slug: 'costillas-bbq-al-horno',
    imageUrl: '/images/recipes/costillas-bbq.webp',
    imageAlt: 'Costillas BBQ al horno con salsa barbacoa Intercasa',
    url: '/recetas/costillas-bbq-al-horno/',
    category: 'Principales',
    introduction: 'Una receta irresistible, tierna y caramelizada. La barbacoa Intercasa aporta sabor ahumado y dulzor natural, ideal para reuniones o fines de semana.',
    ingredients: [
      '1 kg de costillas',
      'Sal, pimienta y ajo (o especias deseadas)',
      '1/2 taza barbacoa Intercasa',
      '2 cdas miel',
    ],
    instructions: [
      'Sazonar bien las costillas por todos los lados.',
      'Hornear 1 hora y 30 mins envueltas en papel de aluminio a 160°C (comprobando cada cierto tiempo hasta que la carne se ablande).',
      'Mezclar barbacoa Intercasa con miel.',
      'Glasear y hornear 10-20 min más.',
      'Servir caliente.',
    ],
    intercasaProducts: [
      {
        name: 'Salsa Barbacoa Intercasa',
        category: 'Salsas',
        link: '/productos/retail/salsa-barbacoa-pe'
      }
    ]
  },
  {
    id: 5,
    title: 'Hamburguesa BBQ con cebolla crujiente',
    description: 'Una hamburguesa jugosa con un toque dulce y ahumado gracias a la barbacoa Intercasa.',
    date: '2024-10-20',
    slug: 'hamburguesa-bbq-cebolla-crujiente',
    imageUrl: '/images/recipes/hamburguesa-bbq.webp',
    imageAlt: 'Hamburguesa BBQ con cebolla crujiente y salsa Intercasa',
    url: '/recetas/hamburguesa-bbq-cebolla-crujiente/',
    category: 'Principales',
    introduction: 'Una hamburguesa jugosa con un toque dulce y ahumado gracias a la barbacoa Intercasa, perfecta para comidas rápidas pero sabrosas.',
    ingredients: [
      'Hamburguesa de carne',
      'Queso cheddar',
      'Salsa barbacoa Intercasa',
      'Cebolla crujiente',
      'Pan de hamburguesa',
      'Lechuga (opcional)',
      'Tomate (opcional)',
    ],
    instructions: [
      'Cocinar la carne y colocar el queso encima.',
      'Untar barbacoa, ketchup y mostaza Intercasa en el pan.',
      'Colocar la carne en el pan, junto con una o dos hojas de lechuga y una rodaja de tomate.',
      'Añadir cebolla crujiente.',
      'Servir.',
    ],
    intercasaProducts: [
      {
        name: 'Salsa Barbacoa Intercasa',
        category: 'Salsas',
        link: '/productos/retail/salsa-barbacoa-pe'
      },
      {
        name: 'Ketchup Intercasa',
        category: 'Ketchup',
        link: '/productos/retail/ketchup-pe'
      },
      {
        name: 'Mostaza Dulce Intercasa',
        category: 'Mostaza',
        link: '/productos/retail/mostaza-dulce-pe'
      }
    ]
  },
  {
    id: 6,
    title: 'Tiras de pollo BBQ',
    description: 'Una opción fácil y deliciosa para almuerzos rápidos. La barbacoa Intercasa aporta sabor intenso.',
    date: '2024-12-05',
    slug: 'tiras-de-pollo-bbq',
    imageUrl: '/images/recipes/tiras-pollo-bbq.webp',
    imageAlt: 'Tiras de pollo BBQ con salsa barbacoa Intercasa',
    url: '/recetas/tiras-de-pollo-bbq/',
    category: 'Principales',
    introduction: 'Una opción fácil y deliciosa para almuerzos rápidos. La barbacoa Intercasa aporta sabor intenso en pocos minutos.',
    ingredients: [
      '400 g pechuga en tiras',
      'Sal y pimienta',
      '3 cdas barbacoa Intercasa',
      '1 cda miel',
    ],
    instructions: [
      'Sazonar el pollo y dorarlo.',
      'Mezclar barbacoa Intercasa con miel.',
      'Añadir al pollo.',
      'Cocinar hasta glasear.',
      'Servir con papas o ensalada.',
    ],
    intercasaProducts: [
      {
        name: 'Salsa Barbacoa Intercasa',
        category: 'Salsas',
        link: '/productos/retail/salsa-barbacoa-pe'
      }
    ]
  },

  // ==========================================
  // RECETAS CON MOSTAZA INTERCASA
  // ==========================================
  {
    id: 7,
    title: 'Ensalada de papa cremosa con mostaza',
    description: 'Una guarnición fresca y cremosa, perfecta para acompañar carnes y parrilladas.',
    date: '2025-01-15',
    slug: 'ensalada-papa-cremosa-mostaza',
    imageUrl: '/images/recipes/ensalada-papa.webp',
    imageAlt: 'Ensalada de papa cremosa con mostaza Intercasa',
    url: '/recetas/ensalada-papa-cremosa-mostaza/',
    category: 'Guarniciones',
    introduction: 'Una guarnición fresca y cremosa, perfecta para acompañar carnes y parrilladas. La mostaza Intercasa aporta el toque justo de acidez.',
    ingredients: [
      '5 papas',
      '1/2 taza mayonesa',
      '1-2 cdas mostaza Intercasa',
      'Cebollín',
      'Sal y pimienta',
    ],
    instructions: [
      'Cocer las papas.',
      'Mezclar mayonesa y mostaza Intercasa.',
      'Integrar las papas con suavidad.',
      'Añadir cebollín y espolvorear sal y pimienta al gusto.',
      'Refrigerar antes de servir.',
    ],
    intercasaProducts: [
      {
        name: 'Mostaza Dulce Intercasa',
        category: 'Mostaza',
        link: '/productos/retail/mostaza-dulce-pe'
      },
      {
        name: 'Mayonesa Intercasa',
        category: 'Salsas',
        link: '/productos/retail/mayonesa-pe'
      }
    ]
  },
  {
    id: 8,
    title: 'Pechuga de pollo a la mostaza cremosa',
    description: 'Un plato elegante y fácil para cualquier día. La mostaza Intercasa crea una salsa suave.',
    date: '2025-03-22',
    slug: 'pechuga-pollo-mostaza-cremosa',
    imageUrl: '/images/recipes/pollo-mostaza.webp',
    imageAlt: 'Pechuga de pollo a la mostaza cremosa Intercasa',
    url: '/recetas/pechuga-pollo-mostaza-cremosa/',
    category: 'Principales',
    introduction: 'Un plato elegante y fácil para cualquier día. La mostaza Intercasa crea una salsa suave y llena de sabor.',
    ingredients: [
      '2 pechugas',
      '1 taza crema o leche evaporada',
      '2 cdas mostaza Intercasa',
      'Mantequilla, sal y pimienta',
    ],
    instructions: [
      'Dorar el pollo en una sartén.',
      'Cuando esté bien dorado, agregar la mantequilla, la crema y mostaza.',
      'Remover bien hasta integrarlo todo.',
      'Cocinar 10 minutos a fuego medio bajo.',
      'Servir con pasta o arroz.',
    ],
    intercasaProducts: [
      {
        name: 'Mostaza Dulce Intercasa',
        category: 'Mostaza',
        link: '/productos/retail/mostaza-dulce-pe'
      }
    ]
  },
  {
    id: 9,
    title: 'Sándwich de jamón y mostaza',
    description: 'Un clásico sencillo y delicioso. La mostaza Intercasa potencia el sabor del jamón.',
    date: '2025-05-10',
    slug: 'sandwich-jamon-mostaza',
    imageUrl: '/images/recipes/sandwich-jamon.webp',
    imageAlt: 'Sándwich de jamón y mostaza Intercasa',
    url: '/recetas/sandwich-jamon-mostaza/',
    category: 'Snacks',
    introduction: 'Un clásico sencillo y delicioso. La mostaza Intercasa potencia el sabor del jamón sin dominarlo.',
    ingredients: [
      'Pan',
      'Jamón',
      'Queso',
      'Mostaza Intercasa',
      'Mantequilla',
    ],
    instructions: [
      'Untar mantequilla y mostaza en el pan.',
      'Añadir jamón y queso.',
      'Cerrar el sándwich.',
      'Dorar en sartén.',
      'Servir caliente.',
    ],
    intercasaProducts: [
      {
        name: 'Mostaza Dulce Intercasa',
        category: 'Mostaza',
        link: '/productos/retail/mostaza-dulce-pe'
      }
    ]
  },

  // ==========================================
  // RECETAS CON ALIOLI INTERCASA
  // ==========================================
  {
    id: 10,
    title: 'Papas bravas canarias con alioli',
    description: 'Una tapa clásica española muy fácil de preparar. El alioli Intercasa aporta cremosidad.',
    date: '2025-07-18',
    slug: 'papas-bravas-canarias-alioli',
    imageUrl: '/images/recipes/papas-bravas.webp',
    imageAlt: 'Papas bravas canarias con alioli Intercasa',
    url: '/recetas/papas-bravas-canarias-alioli/',
    category: 'Tapas',
    introduction: 'Una tapa clásica española muy fácil de preparar. El alioli Intercasa aporta cremosidad y sabor intenso a cualquier tipo de papa.',
    ingredients: [
      '4 papas',
      'Aceite',
      'Sal y paprika',
      'Alioli Intercasa',
    ],
    instructions: [
      'Cortar las papas en cubitos medianos.',
      'Meter las papas en agua con hielo y dejarlas estar durante unos cuantos minutos.',
      'Secar muy bien las papas con papel de cocina.',
      'Freír en aceite de oliva, en la airfrier u hornear a 220° hasta que queden doradas y crujientes.',
      'Preparar alioli Intercasa.',
      'Servir con salsa encima.',
      'Añadir ketchup picante Intercasa si se desea más sabor.',
      'Cerrar con un poco de perejil picado.',
    ],
    intercasaProducts: [
      {
        name: 'Alioli Receta Canaria',
        category: 'Salsas',
        link: '/productos/retail/alioli-receta-canaria-pe'
      },
      {
        name: 'Ketchup Picante Intercasa',
        category: 'Ketchup',
        link: '/productos/retail/ketchup-picante-cristal'
      }
    ]
  },
  {
    id: 11,
    title: 'Sándwich de pollo con alioli',
    description: 'Una opción fresca y rápida para almuerzos. El alioli Intercasa aporta el toque cremoso.',
    date: '2025-09-25',
    slug: 'sandwich-pollo-alioli',
    imageUrl: '/images/recipes/sandwich-pollo.webp',
    imageAlt: 'Sándwich de pollo con alioli Intercasa',
    url: '/recetas/sandwich-pollo-alioli/',
    category: 'Snacks',
    introduction: 'Una opción fresca y rápida para almuerzos. El alioli Intercasa aporta el toque cremoso sin necesidad de más salsas.',
    ingredients: [
      'Pechuga a la plancha',
      'Pan',
      'Alioli Intercasa',
      'Lechuga y tomate',
    ],
    instructions: [
      'Untar alioli Intercasa en el pan.',
      'Añadir el pollo.',
      'Incorporar vegetales.',
      'Cerrar y presionar.',
      'Servir.',
    ],
    intercasaProducts: [
      {
        name: 'Alioli Receta Canaria',
        category: 'Salsas',
        link: '/productos/retail/alioli-receta-canaria-pe'
      }
    ]
  },
  {
    id: 12,
    title: 'Pasta fría con alioli y vegetales',
    description: 'Una ensalada fresca ideal para días calurosos. El alioli Intercasa da textura cremosa.',
    date: '2025-11-08',
    slug: 'pasta-fria-alioli-vegetales',
    imageUrl: '/images/recipes/pasta-fria.webp',
    imageAlt: 'Pasta fría con alioli y vegetales Intercasa',
    url: '/recetas/pasta-fria-alioli-vegetales/',
    category: 'Ensaladas',
    introduction: 'Una ensalada fresca ideal para días calurosos. El alioli Intercasa le da una textura cremosa sin necesidad de más aderezos.',
    ingredients: [
      '250 g pasta corta',
      'Maíz',
      'Jamón o pollo',
      'Pepino, pimiento (rojo, verde, amarillo), tomate, aceitunas negras',
      'Alioli Intercasa',
    ],
    instructions: [
      'Cocer la pasta.',
      'Mezclar con los vegetales.',
      'Añadir alioli Intercasa.',
      'Sazonar.',
      'Refrigerar.',
    ],
    intercasaProducts: [
      {
        name: 'Alioli Receta Canaria',
        category: 'Salsas',
        link: '/productos/retail/alioli-receta-canaria-pe'
      }
    ]
  },
];

/**
 * Obtener todas las recetas
 * @returns {Array} Array de objetos de recetas
 */
export const getAllRecipes = () => {
  return recipesData;
};

/**
 * Obtener una receta por su slug
 * @param {string} slug - Slug de la receta
 * @returns {Object|null} Objeto de receta o null si no se encuentra
 */
export const getRecipeBySlug = (slug) => {
  return recipesData.find(recipe => recipe.slug === slug) || null;
};

/**
 * Obtener una receta por su ID
 * @param {number} id - ID de la receta
 * @returns {Object|null} Objeto de receta o null si no se encuentra
 */
export const getRecipeById = (id) => {
  return recipesData.find(recipe => recipe.id === id) || null;
};

/**
 * Obtener recetas filtradas por tipo de producto
 * Busca recetas que contengan productos de la categoría especificada
 * @param {string} productType - Tipo de producto (ketchup, alioli, mayonesa, barbacoa, mostaza, tomate)
 * @returns {Array} Array de recetas que usan ese tipo de producto
 */
export const getRecipesByProductType = (productType) => {
  if (!productType) return recipesData;
  
  const productTypeLower = productType.toLowerCase();
  
  return recipesData.filter(recipe => {
    return recipe.intercasaProducts?.some(product => {
      const productName = product.name?.toLowerCase() || '';
      const productCategory = product.category?.toLowerCase() || '';
      
      // Mapeo de tipos de producto a términos de búsqueda
      switch (productTypeLower) {
        case 'ketchup':
          return productCategory.includes('ketchup') || productName.includes('ketchup');
        case 'alioli':
          return productName.includes('alioli');
        case 'mayonesa':
          return productName.includes('mayonesa');
        case 'barbacoa':
          return productName.includes('barbacoa');
        case 'mostaza':
          return productCategory.includes('mostaza') || productName.includes('mostaza');
        case 'tomate':
        case 'tomate-frito':
        case 'tomates':
          return productCategory.includes('tomate') || productName.includes('tomate');
        default:
          return false;
      }
    });
  });
};

/**
 * Determina el tipo de producto basándose en el ID del producto
 * @param {string} productId - ID del producto retail
 * @returns {string|null} Tipo de producto para filtrar recetas
 */
export const getProductTypeFromId = (productId) => {
  if (!productId) return null;
  
  const idLower = productId.toLowerCase();
  
  if (idLower.includes('ketchup')) return 'ketchup';
  if (idLower.includes('alioli')) return 'alioli';
  if (idLower.includes('mayonesa')) return 'mayonesa';
  if (idLower.includes('barbacoa')) return 'barbacoa';
  if (idLower.includes('mostaza')) return 'mostaza';
  if (idLower.includes('tomate')) return 'tomate';
  
  return null;
};
